import { FeriadoModel } from "./feriado.model";

export class FeriadoDataModel {
    id: number;
    feriadoId: number;
    ano: string;
    diaMes: string;
    dataCadastro: Date;
    usuarioCadastro: string;
    dataAlteracao: Date;
    usuarioAlteracao: string;
    ativo: boolean;
    feriado: FeriadoModel;
}